// import * as dotenv from 'dotenv';

// dotenv.config();

export const PORT = process.env.PORT || '3000';
// export const API_HOST = process.env.API_HOST || 'http://localhost:8787';
export const API_HOST = process.env.API_HOST || 'https://api.wishdiv.com';
